import { __generator } from "tslib";
function createIntGenerator() {
    var index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                index = 0;
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 5];
                if (!(index < Number.MAX_SAFE_INTEGER)) return [3 /*break*/, 3];
                return [4 /*yield*/, ++index];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                index = 0;
                _a.label = 4;
            case 4: return [3 /*break*/, 1];
            case 5: return [2 /*return*/];
        }
    });
}
var intGenerator = createIntGenerator();
/**
 * Get an integer ID for attaching to a JSON RPC request payload.
 */
export function getPayloadId() {
    return intGenerator.next().value;
}
//# sourceMappingURL=get-payload-id.js.map